import React from 'react';
import SectionHeader from '../../components/layout/SectionHeader';
import useGame from '../../hooks/use-game';

export type HeaderProps = {
  title?: string;
  children?: any;
  showCloseButton?: boolean;
  closeButtonAction?: any;
  hamburgerMenu?: boolean;
  showDashboardIcon?: boolean;
  backRoute?: string;
  omitRoutes?: any;
};

const ActivityHeader: React.FC<HeaderProps> = ({
  title,
  children,
  showCloseButton = false,
  backRoute,
  hamburgerMenu = true,
  omitRoutes,
}) => {
  const [, { handleCloseActivity }] = useGame();
  
  return (
    <SectionHeader
      title={title}
      hamburgerMenu={hamburgerMenu}
      showCloseButton={showCloseButton}
      backRoute={backRoute}
      closeButtonAction={handleCloseActivity}
      omitRoutes={omitRoutes}
    >
      {children}
    </SectionHeader>
  );
};

export default ActivityHeader;
